import React from 'react';

const StrokeWidthPicker = ({ value, onChange, darkMode, hasSelection, selectionLabel }) => {
    return (
        <div className={`p-3 rounded-2xl ${darkMode ? 'bg-white/5' : 'bg-gray-50'}`}>
            <div className="flex items-center justify-between mb-2">
                <span className={`text-[10px] font-bold uppercase tracking-wider ${darkMode ? 'text-gray-400' : 'text-gray-500'
                    }`}>
                    Grosor
                </span>
                <span className={`text-[11px] font-bold px-2 py-0.5 rounded-lg ${darkMode ? 'bg-violet-600/30 text-violet-300' : 'bg-blue-100 text-blue-600'
                    }`}>
                    {value}px
                </span>
            </div>

            {/* Indicator when editing selected element */}
            {hasSelection && (
                <div className={`text-[9px] text-center mb-2 px-2 py-1 rounded-lg ${darkMode
                        ? 'bg-violet-600/30 text-violet-300'
                        : 'bg-blue-100 text-blue-600'
                    }`}>
                    ✏️ {selectionLabel || 'Editando selección'}
                </div>
            )}

            <input
                type="range"
                min="1"
                max="32"
                value={value}
                onChange={(e) => onChange(parseInt(e.target.value))}
                className={`w-full h-2 rounded-lg appearance-none cursor-pointer ${darkMode ? 'accent-violet-500' : 'accent-blue-500'
                    }`}
            />
        </div>
    );
};

export default StrokeWidthPicker;
